import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class DashboardLayoutService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getLayout(pageKey, userId, tenantId) {
        try {
            return await withRetry(
                () => this.api.getLayout({ pageKey, userId, tenantId }),
                { maxRetries: 2 },
            );
        } catch (error) {
            throw this._handleError(error, 'Failed to load layout');
        }
    }

    async saveLayout(payload) {
        try {
            return await this.api.saveLayout(payload);
        } catch (error) {
            throw this._handleError(error, 'Failed to save layout');
        }
    }

    async resetLayout(pageKey, userId, tenantId) {
        try {
            return await this.api.resetLayout({ pageKey, userId, tenantId });
        } catch (error) {
            throw this._handleError(error, 'Failed to reset layout');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) {
            throw error;
        }
        if (error.statusCode || error.status) {
            throw ApiError.fromResponse(error);
        }
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
